<template>
  <div class="form-submit row">
    <div class="col-xs-12 col-md-6">
      <x-button
        v-if="showCancel"
        class="cancel-btn md-raised light"
        :disabled="submitting"
        @click="onCancel"
      >
        <icn-close color="white" />
        {{ $t('buttons.cancel') }}
      </x-button>
    </div>
    <div class="col-xs-12 col-md-6">
      <x-button
        class="md-raised md-primary submit-btn"
        :class="submitting && &quot;submitting&quot;"
        :disabled="submitting || disabled"
        type="submit"
        @click="onSubmit"
      >
        <update-profile-icon
          class="update-icon"
          :loading="submitting"
        />
        {{ submitText || $t('buttons.update-informations') }}
      </x-button>
    </div>
  </div>
</template>

<script>
  import icnClose from '@/svg/icn-close'
  import updateProfileIcon from '@/svg/update-profile-icon'

  export default {
    name: 'XFormSubmit',
    components: {
      icnClose,
      updateProfileIcon
    },
    props: {
      showCancel: {
        type: Boolean,
        default: true
      },
      submitting: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      submitText: {
        type: String
      }
    },
    methods: {
      onSubmit () {
        !this.submitting && this.$emit('submit')
      },
      onCancel () {
        !this.submitting && this.$emit('cancel')
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .form-submit {
    position: absolute;
    z-index: 1;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    transform-origin: bottom;
    animation: appear 400ms;
    margin: 0;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    overflow: hidden;

    .cancel-btn, .submit-btn {
      width: 100%;
      height: 100%;
      border-radius: 0;
    }

    .submit-btn.submitting {
      .update-icon {
        animation: rotate infinite 1s;
      }
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes appear {
    from {
      transform: scaleY(0);
    }
    to {
      transform: scaleY(1);
    }
  }
</style>
